(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inspiration"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.getElementById('inspiration');
    if (!root) return;

    var nav = document.getElementById('inspiration-nav');
    var navBtns = nav ? nav.querySelectorAll('.inspiration__nav-btn') : [];
    var sections = root.querySelectorAll('.inspiration__mood');

    function setActiveMood(mood) {
      root.setAttribute('data-active-mood', mood);
      for (var i = 0; i < navBtns.length; i++) {
        if (navBtns[i].getAttribute('data-mood') === mood) {
          navBtns[i].classList.add('is-active');
        } else {
          navBtns[i].classList.remove('is-active');
        }
      }
    }

    for (var i = 0; i < navBtns.length; i++) {
      navBtns[i].addEventListener('click', function(e) {
        var target = e.currentTarget.getAttribute('data-target');
        var mood = e.currentTarget.getAttribute('data-mood');
        var el = document.getElementById(target);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        setActiveMood(mood);
      });
    }

    if ('IntersectionObserver' in window && sections.length > 0) {
      var observer = new IntersectionObserver(function(entries) {
        var bestEntry = null;
        for (var j = 0; j < entries.length; j++) {
          if (entries[j].isIntersecting) {
            if (!bestEntry || entries[j].intersectionRatio > bestEntry.intersectionRatio) {
              bestEntry = entries[j];
            }
          }
        }
        if (bestEntry) {
          var mood = bestEntry.target.getAttribute('data-mood');
          if (mood) setActiveMood(mood);
        }
      }, {
        rootMargin: '-30% 0px -50% 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });

      for (var k = 0; k < sections.length; k++) {
        observer.observe(sections[k]);
      }
    }

    var firstMood = sections[0] ? sections[0].getAttribute('data-mood') : 'evasion';
    setActiveMood(firstMood || 'evasion');
  })();

  } catch(e) { console.error(e); }
})();
})();
